import * as React from 'react';
import './index.css';
import {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {LegacyNote} from "../../types";
import {getLegacyNote} from "../../api";


const ExportNote: React.FunctionComponent = () => {

    const {noteId} = useParams();
    const [note, setNote] = useState<LegacyNote>();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (noteId !== undefined) {
            setLoading(true);
            getLegacyNote(noteId)
                .then((ld) => {
                    setNote(ld);
                })
                .finally(() => setLoading(false))
        }
    }, []);

    return ((loading) ? <>...Loading note...</> : <>

        <h3>Legacy Note</h3>
        <p className={"note"}>
            <h5>Client Id</h5>
            {note?.clientId}<br/>
            <h5>Session Topic</h5>
            {note?.sessionTopic}<br/>
            <h5>Hours</h5>
            {note?.hours}<br/>
            <h5>Note</h5>
            <pre style={{width: 500}}>{note?.note}</pre><br/>
            <h5>Additional Note</h5>
            <pre style={{width: 500}}>{note?.additionalNote}</pre><br/>
            <h5>Session Date</h5>
            {note?.sessionDate}<br/>
            <h5>Session Time</h5>
            {note?.sessionTime}<br/>
            <h5>Session Notes</h5>
            <pre style={{width: 500}}>{note?.sessionNotes}</pre><br/>
            <h5>Session Progress</h5>
            <pre style={{width: 500}}>{note?.sessionProgress}</pre><br/>
            <h5>Session Activity</h5>
            <pre style={{width: 500}}>{note?.sessionActivity}</pre><br/>
            <h5>Session Contact</h5>
            <pre style={{width: 500}}>{note?.sessionContact}</pre><br/>
        </p>
    </>);
};

export default ExportNote;

